import * as React from "react";
import "./color.scss";

export const Colors = ({tile, mapTileColorsConfig}) => ({
    label: "Colors",
    render: () => <div className="map-tile-colors-6kl">{mapTileColorsConfig.render()}</div>,
});
